'use strict'

import {Vue} from 'ui.vue';

import {TYPES, MODE} from './constants';

export let Plugin = function () {
	this.TYPES = TYPES;
	this.componentName = false;
	this.action = false;
	this.signedParameters = false;
	this.data = false;
	this.mode = MODE.COMPONENT;
}

Plugin.prototype.setModeModule = function() {
	this.mode = MODE.MODULE;
	return this;
}

Plugin.prototype.setModeComponent = function() {
	this.mode = MODE.COMPONENT;
	return this;
}

Plugin.prototype.setAction = function(action) {
	this.action = action;
	return this;
}

Plugin.prototype.setSignedParameters = function(signedParameters) {
	this.signedParameters = signedParameters;
	return this;
}

Plugin.prototype.setData = function(data) {
	this.data = data;
	return this;
}

Plugin.prototype.setOption = function(option = null) {
	if(null === option)
		return;

	this.componentName = option.hasOwnProperty('componentName') ? option.componentName : false;
	this.action = option.hasOwnProperty('action') ? option.action : false;
	this.data = option.hasOwnProperty('data') ? option.data : false;
	this.signedParameters = option.hasOwnProperty('signedParameters') ? option.signedParameters : "";

	return this;
};

Plugin.prototype.send = function () {
	let action = this.action;
	let request = this.data;

	return new Promise((resolve, reject) => {
		let response = null;

		if(MODE.COMPONENT === this.mode) {
			let
				componentName = this.componentName,
				signedParameters = this.signedParameters
			;

			response = BX.ajax.runComponentAction(componentName, action, {
				mode: 'class',
				data: request,
				signedParameters: signedParameters,
				preparePost: true,
				enctype: 'multipart/form-data',
			});
		}
		else {
			response = BX.ajax.runAction(action, {
				data: request,
				preparePost: true,
				enctype: 'multipart/form-data',
			});
		}

		if(null === response) {
			reject('response not correct!');
		}

		response.then((response) => {
				try {
					if (!response.hasOwnProperty('data')) {
						throw new Error('Data not found');
					}

					resolve(response.data);
				} catch (e) {
					reject(e);
				}
			})
			.catch(response => {
				let errors = response.hasOwnProperty('errors') ? response.errors : false;
				if (Array.isArray(errors) && errors.length > 0) {
					reject(errors[0].message);
				} else {
					reject('System error!');
				}
			});
	});
}

Plugin.install = function (Vue, options) {
	Vue.request = new Plugin()

	Vue.request.setOption(options);

	Object.defineProperties(Vue.prototype, {
		$request: {
			get() {
				return Vue.request
			}
		}
	})
}


Vue.use(Plugin);

export default Plugin;